import axios from 'axios';

export const COUPON_VALIDATION_LOADING = 'COUPON_VALIDATION_LOADING';
export const COUPON_VALIDATION_SUCCESS = 'COUPON_VALIDATION_SUCCESS';
export const COUPON_VALIDATION_ERROR = 'COUPON_VALIDATION_ERROR';

export function validateStripeCoupon(coupon, success, failure) {
  return (dispatch) => {
    dispatch({ type: COUPON_VALIDATION_LOADING });

    axios
      .get(`${process.env.REACT_APP_STRIPE_HOST_URL}/coupons/${coupon}`, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_STRIPE_SECRET_KEY}`,
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then((response) => {
        success && success();

        if (response.data.valid) {
          dispatch({
            type: COUPON_VALIDATION_SUCCESS,
            payload: response.data,
          });
        } else {
          dispatch({
            type: COUPON_VALIDATION_ERROR,
            payload: { error: 'Not valid' },
          });
        }
      })
      .catch((result) => {
        failure && failure();

        const error = result.response.status === 404 ? 'Not found' : result;

        dispatch({
          type: COUPON_VALIDATION_ERROR,
          payload: { error },
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/stripeCouponActions.js